import styled from 'styled-components'

export const UndefinedContainer = styled.p`
  font-size: var(--text-1);
  border-radius: var(--border-radius-pill);
  width: fit-content;

  &:hover {
    background-color: var(--gray-100);
  }
`
